import { render } from "./PixelText.vue?vue&type=template&id=c918aefa&scoped=true"
import script from "./PixelText.vue?vue&type=script&lang=js"
export * from "./PixelText.vue?vue&type=script&lang=js"

import "./PixelText.vue?vue&type=style&index=0&id=c918aefa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c918aefa"]])

export default __exports__